// base
import { replace } from 'connected-react-router';
import decode from 'jwt-decode';
import { call, put, takeEvery } from 'redux-saga/effects';
// packages
import { ActionType } from 'typesafe-actions';
// modules
import {
  DELETE_MESSAGE,
  DUPLATE_MESSAGE,
  ERROR_MESSAGE,
  SAVE_MESSAGE
} from '../../../../configs/constants';
import * as Actions from '../actions/authAction';
import { authAPI } from '../apis/authApi';
import { LoginData } from '../models/authModel';
import {
  cookieStorage,
  COOKIE_ACCESS_TOKEN,
  COOKIE_REFRESH_TOKEN
} from '../service/cookie';
import * as MessageActions from '../../../comn/message/actions/comnMessageAction';
import { Console } from 'console';

function* userLoginSaga(action: ActionType<typeof Actions.login.request>) {
  const param = action.payload;
  try {
    const { data, errorCode } = yield call(authAPI.usersLogin, param);

    if (errorCode == '-101') {
      throw '계정 정보를 찾을 수 없습니다. 다시 확인해 주세요.';
    } else if (errorCode == '-102') {
      throw '비밀번호가 잘못되었습니다. 다시 확인해 주세요.';
    } else if (errorCode == '-103') {
      throw '계정 정보가 사용할 수 없는 상태입니다. 다시 확인해 주세요.';
    }
    // access_token 세팅
    cookieStorage.setCookie(COOKIE_ACCESS_TOKEN, data.accessToken);
    cookieStorage.setCookie(COOKIE_REFRESH_TOKEN, data.refreshToken);

    const user = yield call(authAPI.getUserProfile, data.cstmrSno);

    // if (data.userId) {
    //   cookieStorage.setCookie('SAVE_USR_ID', data.userId);
    // } else {
    //   cookieStorage.removeCookie('SAVE_USR_ID');
    // }

    yield put(Actions.login.success({ ...user.data }));
  } catch (error) {
    yield put(Actions.login.failure(error));

    // message.error(error);
  }
}

function* refreshTokenSaga(action: ActionType<typeof Actions.refresh.request>) {
  const param = action.payload;
  try {
    const { data, errorCode } = yield call(authAPI.refreshToken, param);

    // access_token 세팅
    cookieStorage.setCookie(COOKIE_ACCESS_TOKEN, data.accessToken);
    cookieStorage.setCookie(COOKIE_REFRESH_TOKEN, data.refreshToken);

    const user = yield call(authAPI.getUserProfile, data.cstmrSno);

    yield put(Actions.check.success({ ...user.data }));
  } catch (error) {
    yield put(Actions.check.failure(error));
  }
}

function* checkAuthencationSaga() {
  try {
    const accessToken = cookieStorage.getCookie(COOKIE_ACCESS_TOKEN);

    if (!accessToken) {
      yield put(
        Actions.check.success({
          isLogin: false
        })
      );

      return;
    }

    const decodedToken = decode<LoginData>(accessToken);

    const { data } = yield call(authAPI.getUserProfile, decodedToken.cstmrSno);

    //token 셋팅
    cookieStorage.setCookie(COOKIE_ACCESS_TOKEN, accessToken);

    // storageService.session.setItem(STORAGE_SESSION_ICT, user.icToken);

    yield put(
      Actions.check.success({
        isLogin: true,
        user: data
      })
    );
  } catch (error) {
    cookieStorage.removeCookie(COOKIE_ACCESS_TOKEN);

    yield put(Actions.check.failure(error));
  }
}

function* userLogoutSaga() {
  const accessToken = cookieStorage.getCookie(COOKIE_ACCESS_TOKEN);

  try {
    if (accessToken) {
      const decodedToken = decode<LoginData>(accessToken);
      const res = yield call(authAPI.usersLogout, decodedToken.cstmrSno);

      if (res.data == 'SUCCESS') {
        location.href = '/account/login';
      }
    }
    // yield put(Actions.logout.success());
    cookieStorage.removeCookie(COOKIE_ACCESS_TOKEN);
    cookieStorage.removeCookie(COOKIE_REFRESH_TOKEN);

    yield put(replace('/'));
  } catch (error) {
    yield put(Actions.logout.failure(error));
  }
}

function* userPageSaga(
  action: ActionType<typeof Actions.userPageAction.request>
) {
  try {
    const controlId = action.payload;

    const { data } = yield call(authAPI.getUserPage, controlId);

    yield put(Actions.userPageAction.success(data));
  } catch (error) {
    yield put(Actions.userPageAction.failure(error));
  }
}
function* userDeletePageSaga(
  action: ActionType<typeof Actions.userDeleteAction.request>
) {
  try {
    const controlId = action.payload;

    const { data } = yield call(authAPI.deletedata, controlId);
    if (data.result === true) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: '탈퇴가 완료되었습니다',
          isHistoryBack: false,
          isRefresh: true
        })
      );
      //location.href = '/account/login';
      cookieStorage.removeCookie(COOKIE_ACCESS_TOKEN);
      cookieStorage.removeCookie(COOKIE_REFRESH_TOKEN);

      yield put(replace('/'));
      //  yield put(Actions.userDeleteAction.success(data));;
    }

    // yield put(Actions.logout.success());
  } catch (error) {
    yield put(Actions.logout.failure(error));
  }
}
function* userUpdateSaga(
  action: ActionType<typeof Actions.userupdateAction.request>
) {
  const param = action.payload;
  try {
    const { data, errorCode } = yield call(authAPI.updateUser, param);
    yield put(Actions.pwUpdateAction.success(data));
    if (data.errorCode === '-1') {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: ERROR_MESSAGE.code,
          errorMessage: ERROR_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: false
        })
      );
    } else {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: false
        })
      );
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: '처리 중 에러입니다.',
        isHistoryBack: false,
        isRefresh: false
      })
    );
  }
}
function* userPwCheckSaga(
  action: ActionType<typeof Actions.pwCheckAction.request>
) {
  const controlId = action.payload;
  try {
    const { data } = yield call(authAPI.pwcheck, controlId);
    yield put(Actions.pwCheckAction.success(data));
    if (data.errorCode === '-1') {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: ERROR_MESSAGE.code,
          errorMessage: '기존 비밀번호가 일치하지 않습니다.',
          isHistoryBack: false,
          isRefresh: false
        })
      );
    } else {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: '확인이 완료되었습니다.',
          isHistoryBack: false,
          isRefresh: false
        })
      );
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: '처리 중 에러입니다.',
        isHistoryBack: false,
        isRefresh: false
      })
    );
  }
}

function* userPwSaga(
  action: ActionType<typeof Actions.pwUpdateAction.request>
) {
  const param = action.payload;
  try {
    const { data, errorCode } = yield call(authAPI.pwupdate, param);
    //yield put(Actions.pwUpdateAction.success(data));

    if (data.errorCode === '-1') {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: ERROR_MESSAGE.code,
          errorMessage: '기존 비밀번호가 일치하지 않습니다.',
          isHistoryBack: false,
          isRefresh: false
        })
      );
    } else {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: true
        })
      );
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: '처리 중 에러입니다.',
        isHistoryBack: false,
        isRefresh: false
      })
    );
  }
}

// function* updateSaga(action: ActionType<typeof Actions.userupdateAction.request>) {
//   try {
//     const detail = action.payload;
//     const res = yield call(Apis.dronAPI.update, detail);

//     const { data } = res;

//     if (data.result) {
//       yield put(
//         MessageActions.IS_MESSAGE({
//           messageCode: SAVE_MESSAGE.code,
//           message: SAVE_MESSAGE.message,
//           isHistoryBack: true,
//           isRefresh: false
//         })
//       );
//     } else {
//       if (data.errorCode === 'DT002') {
//         yield put(
//           MessageActions.IS_ERROR({
//             errorCode: DUPLATE_MESSAGE.code,
//             errorMessage: '제작번호 ' + DUPLATE_MESSAGE.message,
//             isHistoryBack: false,
//             isRefresh: false
//           })
//         );
//       } else {
//         throw Error;
//       }
//     }
//   } catch (error) {
//     yield put(
//       MessageActions.IS_ERROR({
//         errorCode: ERROR_MESSAGE.code,
//         errorMessage: ERROR_MESSAGE.message,
//         isHistoryBack: false,
//         isRefresh: false
//       })
//     );
//     // yield put(Actions.GROUP_UPDATE.failure(error));
//   }
// }

export function* authSaga() {
  yield takeEvery(Actions.login.request, userLoginSaga);
  yield takeEvery(Actions.check.request, checkAuthencationSaga);
  yield takeEvery(Actions.logout.request, userLogoutSaga);
  // yield takeEvery(Actions.refresh.request, refreshTokenSaga);
  yield takeEvery(Actions.userPageAction.request, userPageSaga);
  yield takeEvery(Actions.pwUpdateAction.request, userPwSaga);
  yield takeEvery(Actions.userupdateAction.request, userUpdateSaga);
  yield takeEvery(Actions.userDeleteAction.request, userDeletePageSaga);
  yield takeEvery(Actions.pwCheckAction.request, userPwCheckSaga);
}
